import { EventTemplate } from '@go-shared/types/eventTemplate';
import React from 'react';
import { useServerInfo } from '@go-client/context/ServerInfoContext';
import { evaluateMcmEndpoint, mcmEndpointToName } from '@go-shared/lib/mcm';
import { notUndefined } from '@go-shared/lib/functional';
import { Tooltip } from '@spark-labs/avocado-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { mcmEndpointToIcon } from '@go-client/lib/mcm';
import { BareContentTemplate, ContentTemplate } from '@go-shared/types/contentTemplate';
import { VenueTemplate } from '@go-shared/types/venueTemplate';

type McmEndpointsProps = {
  template: EventTemplate | BareContentTemplate | ContentTemplate | VenueTemplate;
};

export const McmEndpoints: React.FC<McmEndpointsProps> = ({ template }) => {
  const { mcm } = template;
  const serverInfo = useServerInfo();

  let elements: string[] = [];

  if (mcm?.endpoints) {
    elements = serverInfo.mcmEndpoints
      .map(edp => {
        const mcmVisible = evaluateMcmEndpoint('visible', edp, mcm, mcm);

        return mcmVisible ? edp : undefined;
      })
      .filter(notUndefined);
  }

  if (mcm?.endpoints === undefined || serverInfo.mcmEndpoints.length === elements.length) {
    return <span className="text-navy font-semibold">All</span>;
  }

  if (!elements.length) {
    return <span className="text-smoke italic font-semibold">None</span>;
  }

  return (
    <div className="flex items-center gap-3 whitespace-nowrap text-navy">
      {elements.map(edp => {
        return (
          <Tooltip text={mcmEndpointToName(edp)} key={edp}>
            <FontAwesomeIcon fixedWidth icon={mcmEndpointToIcon(edp, true)} />
          </Tooltip>
        );
      })}
    </div>
  );
};
